<template>
    <v-dialog width="85%" persistent v-model="getIframeViewer.show">
        <v-card flat height="840">
            <v-card-title class="d-flex align-center justify-center">Resource Center Check In</v-card-title>
            <v-card-text>
                <iframe id="myIframe" :src="getIframeViewer.url" width="100%" height="700"></iframe>
            </v-card-text>
            <v-card-actions class="d-flex align-center justify-center">
                <v-btn class="mx-4" color="primary" @click="reload()">Reload</v-btn>
                <v-btn @click="$store.commit('closeIframeViewer')" color="error">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'iframeViewer',
    computed: {
        ...mapGetters(['getIframeViewer'])
    },
    methods: {
        reload() {
            var iframe = document.getElementById("myIframe");
            iframe.src = this.getIframeViewer.url;
        }
    }
}
</script>